import { defineStore } from "pinia";
import {
  IDataProviderData,
  IDataProviderRequest,
} from "@/interfaces/data-provider";
import { $http } from "@/main";
import config from "@/util/constants";
// import { useAuth } from "@/store/auth";

interface ReviewCatalogState {
  reviewSelected: unknown[];
  selectedCatalog: string;
  selectedDataCatId: number;
  updateStatus: any;
  reviewStatusData: IDataProviderData | null;
  updateLogData: IDataProviderData | null;
}

export const useReviewCatalog = defineStore("reviewCatalog", {
  state: (): ReviewCatalogState => ({
    reviewSelected: [],
    selectedCatalog: "",
    selectedDataCatId: 0,
    updateStatus: 0,
    reviewStatusData: null,
    updateLogData: null,
  }),
  // getters: {},
  actions: {
    async getJwtHeader(): Promise<{
      // Authorisation: string;
      "Access-Control-Allow-Origin": string;
      "Access-Control-Allow-Credentials": string;
      "Access-Control-Allow-Methods": string;
      "Access-Control-Allow-Headers": string;
    }> {
      return {
        // Authorisation: "Bearer " + useAuth().accessToken,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
        "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
        "Access-Control-Allow-Headers":
          "Access-Control-Allow-Headers, access-control-allow-methods, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers",
      };
      // return $Amplify.Auth.currentSession().accessToken.jwtToken.then(
      //   (token: string) => ({
      //     Authorisation: "Bearer " + token,
      //   })
      // );
    },
    async updateLocation(payload: {
      catalogUri: string;
      request: Record<string, unknown>;
    }): Promise<number> {
      // const headers = await this.getJwtHeader();
      const t = await $http
        .post(
          `${config.urls.data.getData}${payload.catalogUri}/update`,
          payload.request
          // { headers }
        );
        return t.status;
        // .then(({ status }) => {
        //   // then function recieves 3 variables - data, headers and status
        //   this.updateStatus = status;
        //   console.log("This is catalogue headers - ", status);
        // });
    },
    async updateLocValReviewStatus(payload: {
      locValReviewUri: string;
      request: Record<string, unknown>;
    }): Promise<number> {
      // const headers = await this.getJwtHeader;
      const t = await $http
        .post(
          `${config.urls.data.getData}${payload.locValReviewUri}/insert`,
          payload.request
          // { headers }
        );
        return t.status;
        // .then(({ status }) => {
        //   console.log("this is updateLocValReviewStatus - status - ", status);
        //   this.updateStatus = status;
        // });
    },
    async getReviewStatusData(payload: {
      locReviewUri: string;
      request: IDataProviderRequest;
    }) {
      return await $http
        .post(
          `${config.urls.data.getData}${payload.locReviewUri}/data`,
          payload.request
        )
        .then(({ data }) => {
          this.reviewStatusData = data.data;
        });
    },
    getUpdateLogData(payload: {
      updateLogUri: string;
      request: IDataProviderRequest;
    }) {
      return $http
        .post(
          `${config.urls.data.getData}${payload.updateLogUri}/data`,
          payload.request
        )
        .then(({ data }) => {
          this.updateLogData = data.data;
        });
    },
    // async setSelectedCatalog(catalogUri: string) {
    //   this.selectedCatalog = catalogUri;
    // },
  },
});
